import React from "react";
import { FormattedMessage } from "react-intl";

import { useIntlTranslate } from "../../../../hooks";
import { Button } from "../../../button/Button";
import { Icon } from "../../../icon/Icon";

import "./RefreshButton.scss";

export const RefreshButton = ({ onClick }) => {
  const translate = useIntlTranslate();

  return (
    <div className={"refresh-button"}>
      <Button
        color={"secondary"}
        size={"large"}
        onClick={onClick}
        aria-label={translate("aria_table_refresh")}
      >
        <Icon icon="fa-regular fa-sync-alt" />
        <span>
          <FormattedMessage id="refresh" />
        </span>
      </Button>
    </div>
  );
};
